import { render, staticRenderFns } from "./ExamAttendanceTable.vue?vue&type=template&id=0570938a&scoped=true"
import script from "./ExamAttendanceTable.vue?vue&type=script&lang=js"
export * from "./ExamAttendanceTable.vue?vue&type=script&lang=js"
import style0 from "./ExamAttendanceTable.vue?vue&type=style&index=0&id=0570938a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0570938a",
  null
  
)

export default component.exports